import menuStore from '@modules/layout/layout-menu-store';
import headerTabsStore from '@modules/layout/layout-header-tabs-store';

export default {
  namespaced: true,

  modules: {
    menu: menuStore,
    headerTabs: headerTabsStore,
  },

  state: {
    menuCollapsed: false,
    isMobile: false,
    labelPosition: 'top',
    labelWidthForm: undefined,
    labelWidthFilter: undefined,
    isRootScreen: true,
  },

  getters: {
    menuCollapsed: (state) => state.menuCollapsed,
    isMobile: (state) => !!state.isMobile,
    paginationLayout: (state) =>
      state.isMobile
        ? 'total, prev, pager, next'
        : 'total, sizes, prev, pager, next',
    labelPosition: (state) => state.labelPosition,
    labelWidthForm: (state) => state.labelWidthForm,
    labelWidthFilter: (state) => state.labelWidthFilter,
    isRootScreen: (state) => state.isRootScreen,
  },

  mutations: {
    RESIZE(state, payload) {
      state.isMobile = payload.width < 576;
    },
    
    TOGGLE_MENU(state) {
      state.menuCollapsed = !state.menuCollapsed;
    },
    
    COLLAPSE_MENU(state) {
      state.menuCollapsed = true;
    },

    SET_IS_ROOT_SCREEN(state, payload) {
      state.isRootScreen = payload;
    },
  },

  actions: {
    resize({ commit }, payload) {
      commit('RESIZE', payload);
    },

    toggleMenu({ commit }) {
      commit('TOGGLE_MENU');
    },

    collapseMenu({ commit }) {
      commit('COLLAPSE_MENU');
    },
    
    setIsRootScreen({ commit }, payload) {
      commit('SET_IS_ROOT_SCREEN', payload);
    }
  },
};
